module.exports = __webpack_public_path__ + "img/slide-5.664ac66b.jpg";